<template>
  <Flex direction="column">
    <BaseText
      >{{ t('wavy_onboarding.copy_wavy_data.description', brandName()) }}</BaseText
    >
    <Flex
      direction="column"
      :gap=".25"
    >
      <Flex
        v-for="(item, index) in checkList"
        :key="index"
        :gap=".25"
        align="center"
      >
        <BaseIcon
          name="check"
          size="s"
        />
        <BaseText bold>{{ item.heading }}:</BaseText>
        <BaseText>{{ item.description }}</BaseText>
      </Flex>
    </Flex>
    <BaseAlert
      :text="t('wavy_onboarding.copy_wavy_data.alert')"
      color="warning"
    />
    <BaseCard gray>
      <BaseCheckbox
        v-model="agreeToTerms"
        :label="t('wavy_onboarding.copy_wavy_data.terms')"
        required
        v-test="'wavy-onboarding-copy-data-terms'"
      />
    </BaseCard>
  </Flex>
</template>

<script
  setup
  lang="ts"
>
import { useI18n } from 'vue-i18n';
import { brandName } from '@/helpers/brand-name';

const { t } = useI18n();

const agreeToTerms = ref(false);
const checkList = computed(() => [
  {
    heading: t('wavy_onboarding.copy_wavy_data.checklist.company_info'),
    description: t(
      'wavy_onboarding.copy_wavy_data.checklist.company_info_description',
    ),
  },
  {
    heading: t('wavy_onboarding.copy_wavy_data.checklist.employees'),
    description: t(
      'wavy_onboarding.copy_wavy_data.checklist.employees_description',
    ),
  },
  {
    heading: t('wavy_onboarding.copy_wavy_data.checklist.calendar_data'),
    description: t(
      'wavy_onboarding.copy_wavy_data.checklist.calendar_data_description',
    ),
  },
  {
    heading: t('wavy_onboarding.copy_wavy_data.checklist.customers'),
    description: t(
      'wavy_onboarding.copy_wavy_data.checklist.customers_description',
    ),
  },
  {
    heading: t('wavy_onboarding.copy_wavy_data.checklist.services'),
    description: t(
      'wavy_onboarding.copy_wavy_data.checklist.services_description',
    ),
  },
]);
</script>
